import { SimpleReactComponentProps } from '../../../types/components';

const figureClassNames = 'flex flex-col flex-1';
const imageClassNames = 'grow aspect-[16/9]';
const figcaptionClassNames = 'text-center py-3';

export interface ImageBlockProps extends SimpleReactComponentProps {
	src: string;
	alt: string;
	id?: string;
	showCaption?: boolean;
	figureClassOverrides?: string;
}

export const ImageBlock = ({
	src,
	alt,
	classOverrides,
	showCaption,
	figureClassOverrides,
}: ImageBlockProps) => {
	if (!src) {
		console.error('Missing src in ImageBlock');
		return null;
	}

	return (
		<figure className={figureClassOverrides || figureClassNames}>
			<img
				alt={alt}
				src={src}
				className={classOverrides || imageClassNames}
			></img>
			{showCaption && alt ? (
				<figcaption className={figcaptionClassNames}>{alt}</figcaption>
			) : null}
		</figure>
	);
};
